import ScheduleIndex from "@/pages/lab/schedule/ScheduleIndex";
import ScheduleCalendar from "@/pages/lab/schedule/ScheduleCalendar";
import ScheduleSingle from "@/pages/lab/schedule/ScheduleSingle";
import ScheduleDetail from "@/pages/lab/schedule/ScheduleDetail";
import ScheduleSamples from "@/pages/lab/schedule/ScheduleSamples";
import ScheduleResults from "@/pages/lab/schedule/ScheduleResults";
import ScheduleEdit from "@/pages/lab/schedule/ScheduleEdit";
import GrindingOrderIndex from "@/pages/lab/schedule/GrindingOrderIndex";
import ScheduleAdd from "@/pages/lab/schedule/ScheduleAdd";
import ScheduleCohort from "@/pages/lab/schedule/ScheduleCohort";
import PreviousSchedule from "@/pages/lab/schedule/SchedulePrevious";

export class ScheduleRoutes {
  constructor() {
    this.route_root = "schedules";
    this.type_single = "Schedule";
    this.type_plural = "Schedules";

    this.routes = [
      {
        path: this.route_root,
        component: {
          render(c) {
            return c("router-view");
          }
        },
        redirect: this.route_root,
        name: this.type_plural,
        meta: { requiresAuth: true },
        children: [
          {
            path: "",
            component: ScheduleIndex,
            meta: { requiresAuth: true }
          },
          {
            path: "calendar",
            name: "Schedule Calendar",
            component: ScheduleCalendar,
            meta: { requiresAuth: true }
          },
          {
            path: "add/:date",
            name: "Schedule - New",
            component: ScheduleAdd,
            props: true,
            meta: { requiresAuth: true }
          },
          {
            path: ":schedule_id",
            component: ScheduleSingle,
            children: [
              {
                path: "",
                component: ScheduleDetail,
                name: this.type_single,
                meta: { requiresAuth: true },
              },
              {
                path: "schedule-samples",
                name: "Manage Schedule Samples",
                component: ScheduleSamples,
                props: true,
                meta: { requiresAuth: true }
              },
              {
                path: "sample-cohort",
                name: "Manage Sample Cohort",
                component: ScheduleCohort,
                props: true,
                meta: { requiresAuth: true }
              },
              {
                path: "results",
                name: "Manage Schedule Results",
                component: ScheduleResults,
                props: true,
                meta: { requiresAuth: true }
              },
              {
                path: "grinding-order",
                name: "Grinding Order",
                component: GrindingOrderIndex,
                meta: { requiresAuth: true }
              },
              {
                path: "wizard/:step",
                name: "Schedule Wizard - Edit",
                component: ScheduleEdit,
                props: true,
                meta: { requiresAuth: true }
              },
              {
                path: "previous-schedules",
                name: "Schedule samples from previous schedule",
                component: PreviousSchedule,
                meta: { requiresAuth: true }
              },
            ]
          }
        ]
      }
    ];

    this.public_routes = [];
  }

  static fetchRoutes() {
    let this_obj = new this();
    return this_obj.routes;
  }

  static fetchPublicRoutes() {
    let this_obj = new this();
    return this_obj.public_routes;
  }
}
